<h3 class="header">
  {{ 'SHARED.ORDERTRACKING.ARTICLEORDER' | translate }}
</h3>
<div class="cw-horizontalline"></div>
<span [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></span>

@if (checkIfOrderFormVisible()) {
  <form [formGroup]="orderItemFormGroup">
    <!-- Produkterfassung -->
    <div id="submodule-data">
      <!-- Auswahl Sortiment Filter -->
      @if (orderFormService.orderAccessRightsExplicit['product_range']['ngIf']) {
        <phscw-input-select
          [editMode]="editMode"
          label="{{ 'GENERAL.ASSORTMENT' | translate }}"
          name="productRange"
          inputId="productRange"
          (change)="selectProductRange($any($event.target).value)"
          [selectData]="selectDataProductRange"
          [(ngModel)]="selectedOrderRange"
          [ngModelOptions]="{standalone: true}">
        </phscw-input-select>
      }
      <!-- Auswahl Produktgruppen Filter -->
      <phscw-input-select
        [editMode]="editMode"
        label="{{ 'GENERAL.GROUP' | translate }}"
        name="productGroup"
        inputId="productGroup"
        (change)="selectParentProductId($any($event.target).value)"
        [selectData]="selectDataProductGroups"
        [(ngModel)]="selectedParentProductId"
        [ngModelOptions]="{standalone: true}">
      </phscw-input-select>
      <!-- Auswahl Produkttyp Filter -->
      <phscw-input-select
        [editMode]="editMode"
        label="{{ 'MODULES.REPORTS.SAMPLESINVENTORY.PRODUCTTYPE' | translate }}"
        name="productType"
        inputId="productType"
        [selectData]="selectDataProductTypes"
        [(ngModel)]="selectedProductType"
        [ngModelOptions]="{standalone: true}">
      </phscw-input-select>
      <!-- Suchfeld Produkte -->
      <div class="cw-flex-row cw-search-bar">
        <phscw-input-text
          [editMode]="editMode"
          label="Produkt Suche"
          name="product_search_field"
          inputId="product_search_field"
          [(ngModel)]="productSearchValue"
          [ngModelOptions]="{standalone: true}"
        (keyup.enter)="searchProducts(productSearchValue)"></phscw-input-text>
        <!-- Suchbutton -->
        <span class="icon-search cw-search-icon" (click)="searchProducts(productSearchValue)"></span>
        <!-- Löschbutton -->
        <span class="icon-delete cw-delete" (click)="resetProductSearch()"> </span>
      </div>
      <div class="overflow-container">
        <div class="cw-flex-row cw-samples-inventory-items-header">
          <!-- Platzhalter Duplizieren button -->
          @if (duplicationOrderItemsEnabled) {
            <span class="duplicate-icon-header"></span>
          }
          <span class="cw-erp-number">ERP-Nr.</span>
          <span class="cw-pzn-number">PZN</span>
          <span class="cw-product-label">{{ 'GENERAL.LABEL' | translate }}</span>
          @if (orderFormService.orderAccessRightsExplicit['order_item_delivery_institution_id']['ngIf']) {
            <span class="cw-pzn-number">Empfänger</span>
          }
          @for (date of deliveryDates; track date) {
            <!-- Menge x Lieferdatum -->
            @if (orderFormService.orderAccessRightsExplicit['order_item_amountAtDate']['ngIf']) {
              <span class="cw-amount">
                {{ 'SHARED.ORDERTRACKING.QUANTITY' | translate }}<br />
                {{ date | date: 'dd.MM.yyyy' }}
              </span>
            }
            <!-- kostenlose Menge x Lieferdatum -->
            @if (orderFormService.orderAccessRightsExplicit['order_item_amount_free_at_date']['ngIf']) {
              <span class="cw-amount">
                {{ 'SHARED.ORDERTRACKING.QUANTITYFREE' | translate }}<br />
                {{ date | date: 'dd.MM.yyyy' }}
              </span>
            }
          }
          @if (orderFormService.orderAccessRightsExplicit['order_item_amount_free_reason']['ngIf']) {
            <span class="select">Grund K-Menge</span>
          }
          @if (orderFormService.orderAccessRightsExplicit['order_item_secondary_discount']['ngIf']) {
            <span class="select-secondary-discount">Sekundärrabatt</span>
          }
          @if (orderFormService.orderAccessRightsExplicit['order_item_secondary_discount_reason']['ngIf']) {
            <span class="select">Grund S-Rabatt</span>
          }
          <span class="cw-price">Preis</span>
          @if (orderFormService.orderAccessRightsExplicit['order_item_discount']['ngIf']) {
            <span class="cw-discount">Rabatt</span>
          }
          <span class="cw-price">Gesamt netto</span>
          @if (orderFormService.orderAccessRightsExplicit['order_item_charge']['ngIf']) {
            <span class="cw-batch">Charge</span>
          }
          <!-- Position leeren - Header Platzhalter-->
          @if (editMode && orderItemRowResetEnabled) {
            <span class="cw-row-action"></span>
          }
        </div>
        <div>
          <!-- Artikel -->
          <ng-container formArrayName="productsFormArray">
            @for (item of orderItemFormGroup.controls.productsFormArray['controls']; track item; let i = $index) {
              @if (checkIfOrderItemVisible(item)) {
                <div [formGroupName]="i" class="cw-flex-row" [ngClass]="{'duplicated-row': item.get('is_duplicate')?.value === true}">
                  <!-- Artikel duplizieren / entfernen -->
                  @if (duplicationOrderItemsEnabled) {
                    <div class="duplicate-icon-padding">
                      @if (item.get('is_duplicate')?.value === true) {
                        <phscw-icon
                          iconName="minus"
                          iconClass="duplicate-icon"
                          (iconClicked)="removeDuplicatedOrderItem(i)"
                          matTooltip="Duplikat entfernen"
                          matTooltipShowDelay="300">
                        </phscw-icon>
                      } @else {
                        <phscw-icon
                          iconName="plus"
                          iconClass="duplicate-icon"
                          (iconClicked)="duplicateOrderItem(i)"
                          matTooltip="Duplizieren"
                          matTooltipShowDelay="300">
                        </phscw-icon>
                      }
                    </div>
                  }
                  <phscw-input-text [showTooltip]="true" class="cw-erp-number" formControlName="product_erp_number"></phscw-input-text>
                  <phscw-input-text class="cw-pzn-number" formControlName="pzn"></phscw-input-text>
                  <phscw-input-text class="cw-product-label" formControlName="product_label"></phscw-input-text>
                  @if (orderFormService.orderAccessRightsExplicit['order_item_delivery_institution_id']['ngIf']) {
                    <phscw-input-text
                      class="cw-pzn-number"
                      formControlName="delivery_institution_id"
                      >
                    </phscw-input-text>
                  }
                  @for (
                    deliveryDateItem of deliveryDateIndexes;
                    track $index;
                    let di = $index
                    ) {
                    <ng-container formArrayName="amountPerDeliveryDate">
                      <!-- Menge x Lieferdatum inputs -->
                      <div class="cw-amount-wrapper">
                      <div
                        class="cw-flex-row no-padding cw-amount"
                        [formGroupName]="di">
                        @if (
                          orderFormService.orderAccessRightsExplicit['order_item_amountAtDate']['ngIf'] &&
                          di < this.visibleDeliveryDates
                          ) {
                          <phscw-input-number
                                                [editMode]="
                                                    orderFormService.orderAccessRightsExplicit['order_item_amountAtDate']['editMode'
                                                    ]
                                                "
                                                [required]="
                                                    orderFormService.orderAccessRightsExplicit['order_item_amountAtDate'][
                                                        'required'
                                                    ]
                                                "
                            formControlName="amountAtDate"
                            valueType="integer"
                            [minValue]="0"
                            [maxValue]="getChargeAvailableStockMaxValue(item)"
                            [error]="getAmountAtDateErrors(item, di)"
                            [showErrorMessage]="false"
                            [title]="getAmountAtDateErrors(item, di) ? getChargeAvailableStockErrorMessage(item) : ''"
                            [class.cw-amount-exceed]="checkMaxAndMinOrderAmount(item, di) || isChargeStockExceeded(item)"
                            (click)="overwriteDiscounts(i)"
                            (keydown)="overwriteDiscounts(i)"
                            (input)="overwriteDiscounts(i)">
                          </phscw-input-number>
                        }
                        @if (
                          orderFormService.orderAccessRightsExplicit['order_item_amountAtDate']['ngIf'] &&
                          editMode
                          ) {
                          <button
                            class="icon-plus cw-toolbar-icon"
                            type="button"
                          (click)="changeAmountAtDate(i, di, 1)"></button>
                        }
                        @if (
                          orderFormService.orderAccessRightsExplicit['order_item_amountAtDate']['ngIf'] &&
                          editMode
                          ) {
                          <button
                            class="icon-minus cw-toolbar-icon"
                            type="button"
                          (click)="changeAmountAtDate(i, di, -1)"></button>
                        }
                      </div>
                      @if (getAmountAtDateErrors(item, di)) {
                        <span class="cw-order-amount-error-msg">{{ getChargeAvailableStockErrorMessage(item) }}</span>
                      }
                      </div>
                      <!-- Menge kostenlos x Lieferdatum-->
                      @if (
                        orderFormService.orderAccessRightsExplicit['order_item_amount_free_at_date']['ngIf'] &&
                        di < this.visibleDeliveryDates
                        ) {
                        <div
                          class="cw-flex-row no-padding cw-amount"
                          [formGroupName]="di">
                          <phscw-input-number
                            [editMode]="orderFormService.orderAccessRightsExplicit['order_item_amount_free_at_date']['editMode']"
                            [required]="orderFormService.orderAccessRightsExplicit['order_item_amount_free_at_date']['required']"
                            valueType="integer"
                            formControlName="amountFreeAtDate"
                            [disabled]="!isFreeAmountEnabled(item.get('product_id').value, item.get('order_range').value)"
                            [minValue]="0"
                            [maxValue]="getFreeAmountMax(item.get('product_id').value, item.get('order_range').value)"
                            [error]="item.get('amountPerDeliveryDate').controls[di].get('amountFreeAtDate').value > getFreeAmountMax(item.get('product_id').value, item.get('order_range').value) ? {
                                        rangeError: {
                                          message: 'Max ' + getFreeAmountMax(item.get('product_id').value, item.get('order_range').value)
                                        }
                                      }
                                    : null ">
                          </phscw-input-number>
                          @if (
                            !isFreeAmountEnabled(item.get('product_id').value, item.get('order_range').value)
                            ) {
                            <button
                              class="icon-plus cw-toolbar-icon"
                              type="button"
                              (click)="changeAmountFreeAtDate(i, di, 1)">
                            </button>
                            <button
                              class="icon-minus cw-toolbar-icon"
                              type="button"
                              (click)="changeAmountFreeAtDate(i, di, -1)">
                            </button>
                          }
                        </div>
                      }
                    </ng-container>
                  }
                  <!-- Grund K-Menge -->
                  @if (orderFormService.orderAccessRightsExplicit['order_item_amount_free_reason']['ngIf']) {
                    <phscw-input-select
                      [editMode]="orderFormService.orderAccessRightsExplicit['order_item_amount_free_reason']['editMode']"
                                    [required]="
                                        item.get('amount_free').value > 0
                                    "
                      class="select"
                      formControlName="reason_amount_free"
                      [automaticFirstSelection]="false"
                      [selectData]="selectDataAmountFreeReason">
                    </phscw-input-select>
                  }
                  <!-- Sekundärrabatt -->
                  @if (orderFormService.orderAccessRightsExplicit['order_item_secondary_discount']['ngIf']) {
                    <phscw-input-select
                      [editMode]="orderFormService.orderAccessRightsExplicit['order_item_secondary_discount']['editMode']"
                      [required]="orderFormService.orderAccessRightsExplicit['order_item_secondary_discount']['required']"
                      class="select-secondary-discount"
                      formControlName="secondary_discount"
                      [usePercentOptions]="true"
                      [useFieldLabelAsValue]="true"
                      [showDeleteButton]="true"
                      [selectData]="selectDataSecondaryDiscountFactor">
                    </phscw-input-select>
                  }
                  <!-- Grund Sekundärrabatt -->
                  @if (orderFormService.orderAccessRightsExplicit['order_item_secondary_discount_reason']['ngIf']) {
                    <phscw-input-select
                      [editMode]="orderFormService.orderAccessRightsExplicit['order_item_secondary_discount_reason']['editMode']"
                                    [required]="
                                        item.get('secondary_discount').value !== null &&
                                        item.get('secondary_discount').value !== undefined &&
                                        item.get('secondary_discount').value !== ''
                                    "
                      class="select"
                      formControlName="reason_secondary_discount"
                      [automaticFirstSelection]="false"
                      [selectData]="selectDataSecondaryDiscountReason">
                    </phscw-input-select>
                  }
                  <phscw-input-number
                    class="cw-price"
                    formControlName="unit_price"
                    valueType="currency"
                  [customFormat]="customCurrencyFormat"></phscw-input-number>
                  @if (orderFormService.orderAccessRightsExplicit['order_item_discount']['ngIf']) {
                    <phscw-input-number
                      [editMode]="orderFormService.orderAccessRightsExplicit['order_item_discount']['editMode']"
                      [required]="orderFormService.orderAccessRightsExplicit['order_item_discount']['required']"
                      #discount
                      class="cw-discount"
                      formControlName="discount"
                      valueType="percent"
                      [minValue]="0"
                      [maxValue]="100"
                                [class.cw-amount-exceed]="
                                    discount.mathValue > this.orderDataCopy.order_discount
                                "></phscw-input-number>
                  }
                  <phscw-input-number
                    class="cw-price"
                    formControlName="total_price"
                    valueType="currency"
                  [customFormat]="customCurrencyFormat"></phscw-input-number>
                  @if (orderFormService.orderAccessRightsExplicit['order_item_charge']['ngIf']) {
                    <phscw-input-select
                      [editMode]="orderFormService.orderAccessRightsExplicit['order_item_charge']['editMode']"
                                [required]="
                                    orderFormService.orderAccessRightsExplicit['order_item_charge']['required'] &&
                                    item.get('amount').value > 0
                                "
                      class="cw-batch"
                      formControlName="charge"
                      [selectData]="selectDataProductBatches[item.get('product_id').value]">
                    </phscw-input-select>
                  }
                  <!-- Position leeren -->
                  @if (editMode && orderItemRowResetEnabled) {
                    <div class="cw-row-action">
                      <!-- Nur anzeigen, wenn bei der Position Mengen vorhanden sind -->
                      @if (hasOrderItemContent(i)) {
                        <button
                          matTooltip="Position leeren"
                          matTooltipShowDelay="300"
                          aria-label="Position leeren"
                          class="icon-delete cw-toolbar-icon"
                          type="button"
                          (click)="clearOrderItemRow(i)">
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            }
          </ng-container>
        </div>
      </div>
    </div>
  </form>
}

@if (!editMode) {
  <!-- Grid -->
  <phscw-grid
    #OrderFormItems
    [gridId]="gridId"
    [simpleGrid]="true"
    [gridData]="articleDataReadOnlyView"
    [gridColumns]="articleGridColumns"
    [gridDisplayedColumns]="articleGridDisplayedColumns">
  </phscw-grid>
}
